import React from "react"
import styles from "./Eventos.module.css"


const Eventos = () => {

    return(

        <div className={styles.container}>

<p> Novidades em breve... </p>

        </div>
     
    )

}

export default Eventos